export { default as ADMIN_DATABANK } from './databank';
export { default as ADMIN_DEV_SETTINGS } from './dev-settings';
export { default as ADMIN_INTELLIGENCE } from './intelligence';
export { default as ADMIN_KIOSKS } from './kiosks';
export { default as ADMIN_PATIENTS } from './patients';
export { default as ADMIN_PRACTICES } from './practices';
export { default as ADMIN_PRACTITIONERS } from './practitioners';
export { default as ADMIN_TASKS } from './tasks';
export { default as ADMIN_TRANSACTIONS } from './transactions';
export { default as ADMIN_USERS } from './users';
